var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-score"},[_c('h4',[_vm._v("Detailed Score:")]),_c('ScoreTable',{attrs:{"entity":_vm.prod}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }